import { render, staticRenderFns } from "./profile-just-created.vue?vue&type=template&id=dee8b2de&scoped=true&"
import script from "./profile-just-created.vue?vue&type=script&lang=js&"
export * from "./profile-just-created.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dee8b2de",
  null
  
)

export default component.exports